module.exports = __webpack_public_path__ + "assets/images/02-active_521fa2c83e07e2cbc25816d92064d5fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-two/exercise-1/02-active.png
// module id = 226
// module chunks = 0